import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./Tooltip.css"

interface TooltipCustomProps {
  text: string;
  id: string;
  position?: "top" | "right" | "bottom" | "left";
  maxLength?: number;
  className?: string;
}

export const TooltipCustom: React.FC<TooltipCustomProps> = ({
  text,
  id,
  position = "top",
  maxLength = 70,
  className = "",
}) => {
  if (!text) return null;

  const shouldTruncate = text.length > maxLength;
  const shortText = shouldTruncate ? text.slice(0, maxLength) + "..." : text;

  if (!shouldTruncate) {
    return <span className={className}>{text}</span>;
  }

  const tooltip = (
    <Tooltip id={id} className="custom-tooltip">
      {text}
    </Tooltip>
  );

  return (
    <OverlayTrigger trigger={['hover', 'focus']} placement={position} overlay={tooltip} >
      <span className={`d-block text-wrap break-word custom-tooltip ${className}`}
        style={{ cursor: "pointer" }}>
        {shortText}
      </span>
    </OverlayTrigger>
  );
};
